import './App.css';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { Home } from './app/home/Home';
import { Login } from './app/login/Login';
import { LocalLogin } from './app/local-login/LocalLogin';

function App() {

  return (
    <HashRouter>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="login/index" element={<LocalLogin />} />
        <Route path="/" element={<Home />} />
        <Route path="/sb-atlas" element={<Home />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
